import { render } from "./NewAchievement.vue?vue&type=template&id=684be146&scoped=true"
import script from "./NewAchievement.vue?vue&type=script&lang=js"
export * from "./NewAchievement.vue?vue&type=script&lang=js"

import "./NewAchievement.vue?vue&type=style&index=0&id=684be146&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3857685418/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684be146"]])

export default __exports__